<template>
  <detailTemplate :classCustom="'detail-docs'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>
      <div class="header flex-row flex__left">
        <el-tag v-if="hcCaseDieuxe.status === 'DANGXULY'" size="mini" class="priority lv2">{{hcCaseDieuxe.state}}</el-tag>
        <el-tag v-if="hcCaseDieuxe.status === 'HOANTHANH'" size="mini" class="priority lv4">{{hcCaseDieuxe.state}}</el-tag>
        <el-tag v-if="hcCaseDieuxe.status === 'HUY'" size="mini" class="priority lv1">{{hcCaseDieuxe.state}}</el-tag>
      </div>
      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold margin-top-10 margin-bottom-10"
          >Yêu cầu đăng ký điều xe đột xuất</div>
          <div class="margin-top-10">
            <span class="label-input">Đơn vị yêu cầu:</span>
            <span class="font-weight__bold">{{hcCaseMaster.requestDeptName}}</span>
          </div>
          <div class="margin-top-10 padding-bottom-10 flex-row has-border__bottom">
            <span class="label-input">Người yêu cầu:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">{{hcCaseMaster.requestUserFullname}}</span>
            </div>
            <span class="label-input margin-left-10">vào lúc:</span>
            <el-date-picker
              size="mini"
              class="input-none__border input-border__radius__0 padding-left-0 el-date-picker-bold"
              v-model="hcCaseDieuxe.createTime"
              placeholder="dd/mm/yyyy"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              :prefix-icon="' '"
              :readonly="true"
            ></el-date-picker>
          </div>

          <div class="form-info padding-right-10 padding-bottom-10">
            <el-form ref="form" inline-message>
              <div class="group__info margin-top-10 padding-bottom-10">
                <div class="content">
                  <div class="form-input">
                    <div
                      class="title font-size__medium font-weight__bold margin-bottom-10"
                    >THÔNG TIN YÊU CẦU</div>

                    <el-form-item class="custom-label__input width25" prop="requestType">
                      <span class="label-input">Loại yêu cầu</span>
                      <div style="width: 100%;">
                        <el-tag
                          v-model="hcCaseDieuxe.requestType"
                          size="mini"
                          :class="['margin-top-10','priority','lv3']"
                        >
                          {{hcCaseDieuxe.requestType === 'LIENTINH' ? 'Liên tỉnh': ''}}
                          {{hcCaseDieuxe.requestType === 'NOITHANH' ? 'Nội thành': ''}}
                        </el-tag>
                      </div>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="title">
                      <span class="label-input">Tiêu đề:</span>
                      <el-input
                        type="text"
                        class="input-border__bottom input-border__radius__0 input-font__bold"
                        v-model="hcCaseDieuxe.title"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="description">
                      <span class="label-input">Chi tiết:</span>
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCaseDieuxe.description"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="numberOfPeople">
                      <span class="label-input">Số người đi:</span>
                      <el-input
                        type="text"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCaseDieuxe.numberOfPeople"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="contactNumber">
                      <span class="label-input">Số điện thoại liên hệ:</span>
                      <el-input
                        type="text"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCaseDieuxe.contactNumber"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="fromPlace">
                      <span class="label-input">Địa điểm đi:</span>
                      <el-input
                        type="text"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCaseDieuxe.fromPlace"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="toPlace">
                      <span class="label-input">Địa điểm đến:</span>
                      <el-input
                        type="text"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCaseDieuxe.toPlace"
                        size="mini"
                        :readonly="true"
                      ></el-input>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="startTime">
                      <span class="label-input">Thời gian đi:</span>
                      <el-date-picker
                        size="mini"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCaseDieuxe.startTime"
                        :prefix-icon="' '"
                        type="datetime"
                        format="dd/MM/yyyy HH:mm"
                        :readonly="true"
                      ></el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="endTime">
                      <span class="label-input">Thời gian về:</span>
                      <el-date-picker
                        size="mini"
                        class="input-border__bottom input-border__radius__0"
                        v-model="hcCaseDieuxe.endTime"
                        :prefix-icon="' '"
                        type="datetime"
                        format="dd/MM/yyyy HH:mm"
                        :readonly="true"
                      ></el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25" prop="note">
                      <span
                        :class="['label-input', actions.length < 1 ? '' : 'field-needed']"
                      >Ghi chú:</span>
                      <el-input
                        class="input-border__bottom input-border__radius__0"
                        v-model="note"
                        :placeholder="note"
                        size="mini"
                        :readonly="actions.length < 1"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div class="group__info margin-top-10">
                <div
                  v-if="actions.length > 0"
                  class="title font-size__medium font-weight__bold margin-bottom-10"
                >
                  THÔNG TIN CHỌN XE &nbsp;
                  <el-tooltip content="Thêm xe" placement="right">
                    <el-button
                      size="small"
                      class="addDocs color__blue btn-none__border"
                      @click="addCar"
                      circle
                    >
                      <i class="fas fa-plus-circle font-size__small"></i>
                    </el-button>
                  </el-tooltip>
                </div>
                <div class="ctn">
                  <div v-if="actions.length > 0" class="list-info width__100 flex-row flex__center">
                    <div class="item margin-bottom-10 width__100">
                      <div class="content flex-row width__100 padding-bottom-10">
                        <table class="width__100 margin-top-10 padding-bottom-10">
                          <tr class="tableHeader has-border__bottom">
                            <th>Xe</th>
                            <th>Tài xế</th>
                            <th>Thao tác</th>
                          </tr>
                          <tr v-for="(item, index) in listCurrentSelected" :key="index">
                            <td>
                              <el-select
                                class="margin-top-10 input-none__border has-border__bottom"
                                v-model="item.carId"
                                placeholder="Chọn xe"
                                size="mini"
                                @change="changeCar(item, index)"
                              >
                                <el-option
                                  v-for="car in listCar"
                                  :key="car.id"
                                  :label="`${car.licence} - ${car.manufacturer}`"
                                  :value="car.carId"
                                ></el-option>
                              </el-select>
                            </td>

                            <td>
                              <el-select
                                class="margin-top-10 input-none__border has-border__bottom"
                                v-model="item.driverId"
                                placeholder="Chọn tài xế"
                                size="mini"
                              >
                                <el-option
                                  v-for="driver in listDriver"
                                  :key="driver.id"
                                  :label="driver.fullName"
                                  :value="driver.id"
                                >{{driver.fullName}}</el-option>
                              </el-select>
                            </td>

                            <td>
                              <el-button
                                size="small"
                                type="dagger"
                                class="addDocs color__red btn-none__border"
                                @click="removeCar(item, index)"
                                circle
                                icon="el-icon-delete"
                              ></el-button>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </el-form>
          </div>
        </div>
      </VuePerfectScrollbar>
      <div class="footer">
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              size="mini"
              class="addDocs color__blue btn-none__border"
              v-if="update !== null"
              @click="updateCar"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Thay đổi xe
            </el-button>
            <el-button
              size="mini"
              class="addDocs color__red btn-none__border"
              v-if="cancel !== null"
              @click="cancelRequest()"
            >
              <i class="fas fa-times-circle font-size__small"></i>
              &nbsp;Hủy yêu cầu
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </detailTemplate>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import hanhchinhService from "../../../services/hanhchinhService";
import { EventBus } from "../../../event-bus.js";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
export default {
  name: "dangkyphonghopDetail",
  mixins: [handleRequestErrorMixin],
  components: {
    VuePerfectScrollbar,
    detailTemplate: () => import("../../common/detail.vue"),
    Multiselect: () => import("vue-multiselect")
  },
  created() {
    this.getData();
    this.getAction();
    this.getDrivers();
    this.getCars();
  },
  computed: {
    caseMasterId() {
      return this.$route.params.id;
    }
  },
  watch: {
    caseMasterId() {
      this.getData();
      this.getAction();
      this.getDrivers();
      this.getCars();
    }
  },
  data() {
    return {
      hcCaseMaster: {},
      hcCaseDieuxe: {},
      listCar: [],
      listDriver: [],
      actions: [],
      approve: null,
      decline: null,
      cancel: null,
      update: null,
      currentListCarAndDriver: [],  // Danh sach xe, tai xe da duoc phe duyet
      listCurrentSelected: [],      // Danh sach xe, tai xe dang duoc chon tren giao dien
      note: null,
    };
  },
  methods: {
    backListPage() {
      this.$router.push({
        name: "adminstration-getCar-dx",
        query: this.$route.query,
        params: this.$route.params
      });
    },

    getData() {
      hanhchinhService.carRequestDetail(this.caseMasterId).then(respone => {
        this.currentListCarAndDriver = [];
        this.listCurrentSelected = [];
        this.hcCaseMaster = respone.data.hcCaseMaster;
        this.hcCaseDieuxe = respone.data.hcCaseDieuxe;
        this.currentListCarAndDriver = respone.data.currentListCarAndDriver;
        this.note = this.hcCaseDieuxe.note;

        this.currentListCarAndDriver.forEach(item => {
          this.listCurrentSelected.push({
            carId: item.carId,
            driverId: item.driverId
          });
        });
      });
    },

    changeCar(car, index) {
      for (let i = 0; i < this.listCar.length; i++) {
        if (this.listCar[i].carId === car.carId) {
          this.listCurrentSelected[index].driverId = this.listCar[i].driverId;
          break;
        }
      }
    },

    getAction() {
      hanhchinhService.getAction(this.caseMasterId).then(respone => {
        this.actions = respone.data.actions;
        this.cancel = null;
        this.update = null;
        respone.data.actions.forEach(item => {
          if (item.actionCode === "huyyeucau") {
            this.cancel = item.actionCode;
          } else if (item.actionCode === "capnhat") {
            this.update = item.actionCode;
          }
        });
      });
    },

    getCars() {
      this.listCar = [];
      hanhchinhService.getListCar('DIEU_XE_DX').then(respone => {
        respone.data.listCar.forEach(item => {
          this.listCar.push({
            carId: item.id,
            driverId: item.driverId,
            manufacturer: item.manufacturer,
            licence: item.licencePlate
          });
        });
      });
    },

    getDrivers() {
      hanhchinhService.getListDriverFree('DIEU_XE_DX').then(response => {
        this.listDriver = response.data.listDriver;
      });
    },

    addCar() {
      if (this.listCar.length > 0) {
        let allAdded = true;
        for (let i=0; i<this.listCar.length; i++) {
          let addCar = this.listCar[i];
          let added = false;
          for (let j=0; j<this.listCurrentSelected.length; j++) {
            if (this.listCurrentSelected[j].carId === addCar.carId || this.listCurrentSelected[j].driverId === addCar.driverId) {
              added = true;
              break;
            }
          }
          if (!added) {
            this.listCurrentSelected.push({
              carId: addCar.carId,
              driverId: addCar.driverId
            });
            allAdded = false;
            break;
          }
        }
        if (allAdded) {
          this.notify(
            "Lỗi",
            "Tất cả xe đã được thêm trong danh sách",
            "error",
            2000
          );
        }
      }
    },

    removeCar(car, index) {
      this.listCurrentSelected.splice(index, 1);
    },

    checkSelectedCar() {
      if (this.listCurrentSelected.length === 0) {
        this.notify(
          "Lỗi",
          "Vui lòng chọn xe và tài xế",
          "error",
          2000
        );
        return false;
      } else if (this.listCurrentSelected.length > 1) {
        for (let i = 0; i < this.listCurrentSelected.length - 1; i++) {
          for (let j = i + 1; j < this.listCurrentSelected.length; j++) {
            if (
              this.listCurrentSelected[i].carId ===
              this.listCurrentSelected[j].carId ||
              this.listCurrentSelected[i].driverId ===
              this.listCurrentSelected[j].driverId
            ) {
              this.notify(
                "Lỗi",
                "Xe hoặc tài xế đã được chọn",
                "error",
                2000
              );
              return false;
            }
          }
        }
      }
      return true;
    },

    cancelRequest() {
      if (!this.note) {
        return this.notify(
          "Lỗi",
          "Vui lòng nhập ghi chú",
          "error",
          2000
        );
      }

      let submitForm = {
        caseMasterId: this.caseMasterId,
        note: this.note
      };

      this.$confirm("Bạn có chắc muốn hủy yêu cầu không?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        hanhchinhService
          .cancelCar(submitForm)
          .then(() => {
            this.notify("Thông báo", "Hủy yêu cầu thành công", "success", 2000);
            EventBus.$emit("eventCalled", {});
            this.backListPage();
          }).catch(error => this.commonHandleRequestError(error));
      });
    },

    updateCar() {
      if (this.checkSelectedCar()) {
        let submitForm = {
          caseMasterId: this.caseMasterId,
          listCarIdAndDriver: this.listCurrentSelected,
          note: this.note
        };

        this.$confirm("Bạn có chắc muốn cập nhật cầu không?", {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning"
        }).then(() => {
          hanhchinhService
            .updateCar(submitForm)
            .then(response => {
              this.notify(
                "Thông báo",
                "Cập nhật yêu cầu thành công",
                "success",
                2000
              );
              EventBus.$emit("eventCalled", {});
              this.backListPage();
            }).catch(error => this.commonHandleRequestError(error));
        });
      }
    }
  }
};
</script>

<style scoped>
.tableHeader {
  height: 35px;
}
.errMsg {
  color: red;
  font-size: 11px;
}
tr {
  text-align: center;
}
th {
  font-size: 13px;
  color: black;
  border-bottom: 1px solid #e3e8ee;
}
table {
  border: 1px solid #e3e8ee;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/dieuXeDotXuat_Detail.vue